import { useCallback, useMemo } from 'react';

import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useMemberships } from '@sayyesschool/frontend/features/memberships';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import MembershipForm from '@/components/memberships/membership-form';
import MembershipsList from '@/components/memberships/memberships-list';

function LearnerMembershipsView({ learner, memberships, createMembership, deleteMembership }) {
    const [membership, toggleMembership] = useBoolean(false);

    const handleSubmit = useCallback(data => {
        return createMembership(data).finally(() => {
            toggleMembership(false);
        });
    }, [createMembership, toggleMembership]);

    const handleDelete = useCallback(id => {
        return deleteMembership(id);
    }, [deleteMembership]);

    return (
        <PageSection
            className="LearnerMemberships"
            title="Абонементы"
            actions={[{
                key: 'add',
                icon: 'add',
                title: 'Создать абонемент',
                onClick: toggleMembership
            }]}
            compact
        >
            {memberships?.length > 0 &&
                <MembershipsList
                    memberships={memberships}
                    onDelete={handleDelete}
                />
            }

            <FormDialog
                title="Новый абонемент"
                open={membership}
                onClose={toggleMembership}
            >
                <MembershipForm
                    id="membership-form"
                    membership={{ userId: learner.id }}
                    onSubmit={handleSubmit}
                />
            </FormDialog>
        </PageSection>
    );
}

export default function LearnerMemberships({ learner }) {
    const query = useMemo(() => ({ userId: learner.id }), [learner.id]);

    const [memberships, actions] = useMemberships(query);
    const lernerMemberships = memberships?.filter(m => m.userId === learner.id);

    return (
        <LearnerMembershipsView
            learner={learner}
            memberships={lernerMemberships}
            createMembership={actions.createMembership}
            deleteMembership={actions.deleteMembership}
        />
    );
}